/* eslint-disable @typescript-eslint/no-explicit-any */

import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { MobileStream } from '../sharedDisplays'
import { MobileProfile } from './displays/MobileProfile'
import { MobileSingle } from './displays/MobileSingle'
import { getContainerStyles } from './styles'

const contentCharacterLimit = 2200
const contentPlaceholderText = 'Add caption...'

const displays: { [key: string]: React.FC<any> } = {
  mobileSingle: MobileSingle,
  mobileStream: MobileStream,
  mobileSingleProfile: MobileProfile,
  default: MobileSingle,
}
const matchDisplay: (display: string) => React.FC<any> = (display) =>
  displays[display] || displays.default

export type Props = {
  accountImage?: AssetReference
  accountName?: string
  accountUsername?: string
  assets: AssetReference[] | []
  content: string
  collabAccount?: string
  display: string
  effect?: string
  instagramCollab?: boolean
  isPresenting: boolean
  musicTitle?: string
  onExpandAsset: () => void
  onRemoveAsset: () => void
  postType: string
  truncate: boolean
  readOnly: boolean
  updateCoverAsset: (val: string, assetId?: number) => void
  updateText: (value: string, destination: string) => void
}

export const InstagramReel: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  assets,
  content,
  collabAccount,
  display,
  effect = '',
  instagramCollab,
  isPresenting = false,
  musicTitle = '',
  onExpandAsset = () => {
    /* */
  },
  onRemoveAsset = () => {
    /* */
  },
  postType,
  readOnly = false,
  truncate,
  updateCoverAsset,
  updateText,
}) => {
  const RenderDisplay = matchDisplay(display)

  const onContentChange = (value: string) => {
    updateText(value, 'content')
  }

  const onMusicChange = (value: string) => {
    updateText(value, 'music_title')
  }

  const video = assets[0] || null

  return (
    <div
      css={getContainerStyles(display)}
      className={kuiperClassNames(
        `instagram instagram-reel instagram-reel-${display}`
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountName={accountName}
        accountUsername={accountUsername}
        asset={video}
        contentCharacterLimit={contentCharacterLimit}
        contentPlaceholderText={contentPlaceholderText}
        content={content}
        effect={effect}
        collabAccount={collabAccount}
        instagramCollab={instagramCollab}
        isPresenting={isPresenting}
        maintainAspectRatio={true}
        musicTitle={musicTitle}
        onContentChange={onContentChange}
        onExpandAsset={onExpandAsset}
        onMusicChange={onMusicChange}
        onRemoveAsset={onRemoveAsset}
        postType={postType}
        readOnly={readOnly}
        truncate={truncate}
        updateCoverAsset={updateCoverAsset}
      />
    </div>
  )
}
